import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var Panorama = function Panorama() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    _jsx("svg", {
      viewBox: "0 0 18 19",
      fill: "none",
      width: "18px",
      height: "19px",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6 5a1 1 0 011-1h4a1 1 0 011 1v4h-1v5H9.667L9 10.087 8.333 14H7V9H6V5zm-3.21 8c-.703.433-.79.758-.79.86 0 .066.027.213.248.441.227.233.605.492 1.155.74.903.406 2.145.726 3.597.883v-.986l3.25 2.03L7 19v-1.066c-1.698-.164-3.232-.536-4.418-1.07-.69-.31-1.308-.696-1.768-1.17C.35 15.218 0 14.597 0 13.86c0-1.16.842-2.009 1.74-2.563.94-.579 2.205-1.01 3.623-1.28l.372 1.966c-1.273.241-2.282.609-2.945 1.017zm12.42 0c-.663-.408-1.672-.776-2.945-1.018l.372-1.964c1.418.268 2.683.7 3.622 1.28C17.158 11.85 18 12.7 18 13.86c0 1.16-.844 2.01-1.745 2.565-.94.579-2.209 1.01-3.629 1.28l-.371-1.966c1.276-.241 2.288-.609 2.952-1.018.706-.434.793-.76.793-.861 0-.102-.087-.427-.79-.86z",
        fill: "#0468FF"
      })
    })
  );
};
Panorama.displayName = 'Panorama';